<!-- Breadcrumb -->
<app-campaign-breadcrumb
[stateAction]="this.stateAction"
[messageInstanceId]="this.messageInstanceId"
[campaignId]="this.campaignId"
[actionTypeCode]="actionTypeCode"
[actionId]="this.campaignActionId"
[actualStep]="this.actualStep">
</app-campaign-breadcrumb>

<!-- Titolo -->
<div class="ui-g-12 campaign-step-title flex-align-center">
  <h2>{{ 'campaign.actionFruitionSetup' | translate }}</h2>
</div>
<!-- Form Date di Fruizione -->
<section class="ui-g-12">
  <h3 class="section-title">
    {{ 'campaign.setFruitionDates' | translate }}
  </h3>
  <div
    class="ui-g-12"
    *ngIf="
      !showFruitionDatesForm &&
      fruitionDatesForm &&
      calendarTranslateService &&
      calendarTranslateService.pcalendarTranslate &&
      setDefaultDateStart() &&
      setDefaultDateEnd()
    "
  >
    <p style="font-weight: 600;">
      {{ 'campaign.messageFruitionDates' | translate:{startDate: setDefaultDateStart(true), endDate: setDefaultDateEnd(true)} }}
      <a style="margin-left: 15px; cursor: pointer;" (click)="showFruitionDatesForm = true">
        <i class="fa fa-pencil" aria-hidden="true"></i>
        <span>{{ 'common.edit' | translate }}</span>
      </a>
    </p>
  </div>
  <form *ngIf="fruitionDatesForm && showFruitionDatesForm" [formGroup]="fruitionDatesForm" [ngClass]="{'invalid-submit': invalidSubmit}">
    <div class="ui-g-12 ui-md-10 flex-align-center">
      <div class="ui-g-12 ui-md-4 emission-date-col">
        <label class="required top-label">{{ 'common.from' | translate }}</label>
        <app-kv-calendar
        *ngIf="emissionStartDate"
          #startDateField
          [inputName]="'startDate'"
          [formData]="fruitionDatesForm"
          [startDateSelector]="true"
          [minDate]="emissionStartDate"
          [maxDate]="defaultEndDate"
          [endDateInputName]="'endDate'"
          [endDateCalendar]="endDateField"
          [defaultDate]="setStartDate()"
        ></app-kv-calendar>
        <span class="input-error-notification" *ngIf="invalidSubmit && fruitionDatesForm.controls['startDate'].errors?.required">{{ 'common.required_error' | translate }}</span>
      </div>
      <div class="ui-g-12 ui-md-4 emission-date-col">
        <label class="required top-label">{{ 'common.to' | translate }}</label>
        <app-kv-calendar
        *ngIf="emissionEndDate"
          #endDateField
          [inputName]="'endDate'"
          [formData]="fruitionDatesForm"
          [endDateSelector]="true"
          [startDateInputName]="'startDate'"
          [minDate]="emissionEndDate"
          [maxDate]="defaultEndDate"
          [startDateCalendar]="startDateField"
          [defaultDate]="setEndDate()"
        ></app-kv-calendar>
        <span class="input-error-notification" *ngIf="invalidSubmit && fruitionDatesForm.controls['endDate'].errors?.required">{{ 'common.required_error' | translate }}</span>
      </div>
    </div>
    <!-- Flessibilità Date -->
    <!--
    <div class="ui-g-12 ui-md-10 flex-align-center" style="margin-top: 10px;">
      <div class="ui-g-12 ui-md-3">
        <label>{{ 'campaign.flexibleDateFruition' | translate }}</label>
      </div>
      <div class="ui-g-12 ui-md-1">
        <p-checkbox
          class="tp-checkbox"
          name="flgFlexibility"
          [binary]="true"
          formControlName="flgFlexibility">
        </p-checkbox>
      </div>
      <div class="ui-g-12 ui-md-3" *ngIf="fruitionDatesForm.get('flgFlexibility').value">
        <label>{{ 'campaign.flexibilityDaysNumber' | translate }}</label>
      </div>
      <div class="ui-g-12 ui-md-3" *ngIf="fruitionDatesForm.get('flgFlexibility').value">
        <input type="number" pInputText formControlName="dayFlexibility">
      </div>
    </div>
    -->
  </form>
  <div class="ui-g-12 ui-md-10 flex-align-center" style="margin-top: 10px;">
    <div class="ui-g-12 ui-md-3">
      <label>{{ 'campaign.typeOfCoupon' | translate }}</label>
    </div>
    <div class="ui-g-12 ui-md-3">
      <label class="red"> {{ couponUseType }}</label>
    </div>
  </div>
  <!-- Check Carta Necessaria -->
  <div class="ui-g-12 ui-md-10 flex-align-center" style="margin-top: 10px;">
    <div class="ui-g-12 ui-md-3">
      <label>{{ 'campaign.cardRequired' | translate }}</label>
    </div>
    <div class="ui-g-12 ui-md-1">
      <p-checkbox
        class="tp-checkbox"
        name="flagCardHolder"
        [binary]="true"
        [(ngModel)]="flagCardHolder">
      </p-checkbox>
    </div>
    <div class="ui-g-12 ui-md-3">
      <p-dropdown
        *ngIf="flagCardHolder && cardHolderTypes && cardHolderTypes.length > 0"
        class="coupon-dropdown"
        [options]="cardHolderTypes"
        [style]="{'width':'100%'}"
        [(ngModel)]="selectedCardHolder"
        [disabled]="!flagCardHolder">
      </p-dropdown>
    </div>
  </div>
  <!-- Coupon Rolling -->
  <div class="ui-g-12 ui-md-10 flex-align-center" style="margin-top: 10px;" *ngIf="flgRolling==1">
    <div class="ui-g-12 ui-md-3">
      <label>{{ 'campaign.determineCouponStartDate' | translate }}</label>
    </div>
    <div class="ui-g-12 ui-md-4">
      <p-dropdown
        class="coupon-dropdown"
        [options]="couponValidityStartDate"
        [style]="{'width':'100%'}"
        [(ngModel)]="selectedCouponValidityStart"
        (onChange)="changeValidity()">
      </p-dropdown>
      <span class="input-error-notification" *ngIf="invalidSubmit && (flgRolling == 1 && !selectedCouponValidityStart)">{{ 'common.required_error' | translate }}</span>
    </div>
    <div class="ui-g-12 ui-md-3">
      <app-coupon-validity *ngIf="selectedCouponValidityStart" 
        [selectedCouponValidity]="selectedCouponValidityStart"
        [selectedCouponValidityValue]="startValidityValue"
        [minFruitionDate]="fruitionDatesForm.get('startDate').value"
        [maxFruitionDate]="fruitionDatesForm.get('endDate').value" 
        (onInsert)="getStartValidityValue($event)">
      </app-coupon-validity>
      <span class="input-error-notification" *ngIf="invalidSubmit && selectedCouponValidityStart && (selectedCouponValidityStart.param_functional_code && !startValidityValue)">
        <div class="ui-g-12">{{ 'common.required_error' | translate }}</div>
      </span>
    </div>
  </div>
  <div class="ui-g-12 ui-md-10 flex-align-center" style="margin-top: 10px;" *ngIf="flgRolling==1">
    <div class="ui-g-12 ui-md-3">
      <label>{{ 'campaign.determineCouponEndDate' | translate }}</label>
    </div>
    <div class="ui-g-12 ui-md-4">
      <p-dropdown
        class="coupon-dropdown"
        [options]="couponValidityEndDate"
        [style]="{'width':'100%'}"
        [(ngModel)]="selectedCouponValidityEnd"
        (onChange)="changeValidity()">
      </p-dropdown>
      <span class="input-error-notification" *ngIf="invalidSubmit && (flgRolling == 1 && !selectedCouponValidityEnd)">{{ 'common.required_error' | translate }}</span>
    </div>   
    <div class="ui-g-12 ui-md-3">
      <app-coupon-validity *ngIf="selectedCouponValidityEnd" 
        [selectedCouponValidity]="selectedCouponValidityEnd"
        [selectedCouponValidityValue]="endValidityValue" 
        [minFruitionDate]="fruitionDatesForm.get('startDate').value"
        [maxFruitionDate]="fruitionDatesForm.get('endDate').value" 
        (onInsert)="getEndValidityValue($event)">
      </app-coupon-validity>
      <span class="input-error-notification" *ngIf="invalidSubmit && selectedCouponValidityEnd && (selectedCouponValidityEnd.param_functional_code && !endValidityValue)">
        <div class="ui-g-12">{{ 'common.required_error' | translate }}</div>
      </span>
    </div>
  </div>
</section>
<!-- Selezione Touchpoint -->
<section class="ui-g-12">
  <h3 class="section-title">
    {{ 'campaign.setFruitionTouchpointTitle' | translate }}
  </h3>
  <app-campaign-touchpoints
    [actionId]="actionId"
    [messageInstanceId]="messageInstanceId"
    [scope]="'fruition'"
    [actionTypeCode]="actionTypeCode"
    [invalidSubmit]="invalidSubmit && !flgConfirmEmission"
    [tpWithoutStores]="tpWithoutStores"
    (onTpSet)="setTouchpoints($event)"
    (tpSelected)="onTouchpointSelection($event)"
    [disableTouchpoint]="flgConfirmEmission">
  </app-campaign-touchpoints>
  <!-- Flag Conferma Negozi di Emissione -->
  <div class="ui-g-12 ui-md-10 flex-align-center" *ngIf="ochannelInBoth">
    <div class="ui-g-12 ui-md-4">
      <label>{{ 'campaign.confirmEmissionStores' | translate }}</label>
    </div>
    <div class="ui-g-12 ui-md-3">
      <p-checkbox
        class="tp-checkbox"
        name="flgConfirmEmission"
        [binary]="true"
        [(ngModel)]="flgConfirmEmission">
      </p-checkbox>
    </div>
  </div>
</section>
<!-- Save -->
<section class="ui-g-12" style="padding-bottom: 100px;">
  <div class="ui-g-12 ui-md-10 text-right">
    <button [disabled]="!compareDatesForStartValidityDate()"
      pButton
      (click)="checkBarcodeAvailability()"
      type="button"
      class="k-generic-btn"
      label="{{ 'common.save' | translate }}">
    </button>
  </div>
</section>



// WEBPACK FOOTER //
// ./src/app/views/campaign-2.0/coupon-fruition-setup/coupon-fruition-setup.component.html